import { render, staticRenderFns } from "./ViewPatientEventEdit.vue?vue&type=template&id=27a2ef5a&"
import script from "./ViewPatientEventEdit.vue?vue&type=script&lang=js&"
export * from "./ViewPatientEventEdit.vue?vue&type=script&lang=js&"
import style0 from "./ViewPatientEventEdit.vue?vue&type=style&index=0&id=27a2ef5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports